import React from "react";
import ImgCarousel from "./ImgCarousel";
import AcLocaisCulto from "./Accordions/ac_locaisculto";
import AcSaude from "./Accordions/ac_saude";
import SliderFeriados from "./SliderFeriados";
import Weather from "./Weather";
import "../../styles/cidadeAveiro.css";
import Transportes from "../../imgs/CidadeAveiro/autocarros.png";
import Seguranca from "../../imgs/CidadeAveiro/seguranca.jpg";
import MoneyBag from "../../imgs/Icons/money_bag.svg";
import Restaurant from "../../imgs/Icons/restaurant.svg";
import Home from "../../imgs/Icons/home.svg";

import { withNamespaces } from 'react-i18next';

const CidadeAveiro = ({ t }) => {
  return (
    <>
      <div className="container">
        {/* AREA 1 SOBRE AVEIRO */}
        <div id="1" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleCidadeAveiro:S1.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S1.P1') }}>
            </p>
            <p className="p_next">
              {t('moduleCidadeAveiro:S1.P2')}
            </p>
            <ImgCarousel />
          </div>
        </div>
        {/* AREA 2 VIDA DO QUOTIDIANO */}
        <div id="2" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleCidadeAveiro:S2.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <div id="saude_bemEstar" className="fantasmaAncora"></div>
            <h3>{t('moduleCidadeAveiro:S2.ST1.ST')}</h3>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST1.P1') }}>
            </p>
            <p className="p_next"><span
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST1.P2') }}>
            </span>
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleCidadeAveiro:S2.ST1.Link')}>{t('moduleCidadeAveiro:S2.ST1.Link')}</a></p>
            <div className="accordions_margin">
              <AcSaude />
            </div>

            <div id="transportes" className="fantasmaAncora"></div>
            <h3>{t('moduleCidadeAveiro:S2.ST2.ST')}</h3>
            <img
              src={Transportes}
              alt={t('moduleCidadeAveiro:S2.ST2.Alt')}
              className="img_only_next"
            />
            <p className="p_next">
              {t('moduleCidadeAveiro:S2.ST2.P1')}
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST2.P2') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST2.P3') }}>
            </p>
            <p className="p_next">
              <span
                dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST2.P4') }}>
              </span>
              <a className='link' target='_blank' rel='noreferrer' href={t('moduleCidadeAveiro:S2.ST2.Link')}>
                {t('moduleCidadeAveiro:S2.ST2.Link')}
              </a>
            </p>
            <div id="clima" className="fantasmaAncora"></div>
            <h3>{t('moduleCidadeAveiro:S2.ST3.ST')}</h3>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST3.P1') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST3.P2') }}>
            </p>
            <div className="box_weather marginB_section">
              <Weather />
            </div>

            <div id="trabalhar_portugal" className="fantasmaAncora"></div>
            <h3>{t('moduleCidadeAveiro:S2.ST4.ST')}</h3>
            <p className="p_next">
              {t('moduleCidadeAveiro:S2.ST4.P1')}
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST4.P2') }}>
            </p>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST4.P3') }}>
            </p>

            <div id="locais_culto" className="fantasmaAncora"></div>
            <h3>{t('moduleCidadeAveiro:S2.ST5.ST')}</h3>
            <p className="p_next">
              {t('moduleCidadeAveiro:S2.ST5.P1')}
            </p>
            <div className="accordions_margin">
              <AcLocaisCulto />
            </div>

            <div id="custo_vida" className="fantasmaAncora"></div>
            <h3>{t('moduleCidadeAveiro:S2.ST6.ST')}</h3>
            {/*ICONS + TEXTO */}
            <div className="row">
              <div className="col-2 col-xl-1 mb-4">
                <img src={MoneyBag} alt={t('moduleCidadeAveiro:S2.ST6.ICON1.Alt')} className="icon_size" />
              </div>
              <div className="col-9 col-xl-11">
                <p className="p_next title_custo">{t('moduleCidadeAveiro:S2.ST6.ICON1.T')}</p>
                <p>{t('moduleCidadeAveiro:S2.ST6.ICON1.P')}</p>
              </div>
              <div className="col-2 col-xl-1 mb-4">
                <img src={Restaurant} alt={t('moduleCidadeAveiro:S2.ST6.ICON2.Alt')} className="icon_size" />
              </div>
              <div className="col-9 col-xl-11">
                <p className="p_next title_custo">{t('moduleCidadeAveiro:S2.ST6.ICON2.T')}</p>
                <p>{t('moduleCidadeAveiro:S2.ST6.ICON2.P')}</p>
              </div>
              <div className="col-2 col-xl-1 marginB_section">
                <img src={Home} alt={t('moduleCidadeAveiro:S2.ST6.ICON3.Alt')} className="icon_size" />
              </div>
              <div className="col-9 col-xl-11">
                <p className="p_next title_custo">{t('moduleCidadeAveiro:S2.ST6.ICON3.T')}</p>
                <p>{t('moduleCidadeAveiro:S2.ST6.ICON3.P')}</p>
              </div>
            </div>

            <div id="seguranca_aveiro" className="fantasmaAncora"></div>
            <h3>{t('moduleCidadeAveiro:S2.ST7.ST')}</h3>
            <p className="p_next"
              dangerouslySetInnerHTML={{ __html: t('moduleCidadeAveiro:S2.ST7.P1') }}>
            </p>
            <img
              src={Seguranca}
              alt="Uma das vistas da Ria de Aveiro"
              className="img_only_next"
            />
          </div>
        </div>

        {/* AREA 3 FERIADOS IMPORTANTES */}
        <div id="3" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3">
            <h2>{t('moduleCidadeAveiro:S3.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8 p-0">
            <SliderFeriados />
          </div>
        </div>

        {/* AREA 4 SOBRE PORTUGAL */}
        <div id="4" className="fantasmaAncora"></div>
        <div className="row mb-3 mt-4">
          <div className="col-md-4 mb-3" id="1">
            <h2>{t('moduleCidadeAveiro:S4.T')}</h2>
            <div className="orange_line"></div>
          </div>
          <div className="col-md-8">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/rqWdEUbKlgA"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={t('moduleCidadeAveiro:S4.Title1')}
            ></iframe>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/GU5W1LecyXw"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={t('moduleCidadeAveiro:S4.Title2')}
            ></iframe>
            <iframe
              src="https://www.youtube.com/embed/6JhRMryTqMo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={t('moduleCidadeAveiro:S4.Title3')}
            ></iframe>
            {/*VIDEOS PT*/}
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(CidadeAveiro);
